import { createSlice,current } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { getChatHistoryData, getUpdatedHistoryData, getUpdatedHistoryDataUpload, reconnectChatImagePending, reconnectUpdateHistory, updateDeletedMessageInHistory, updateMediaUploadStatusHistory, updateMessageTranslate } from "../../Helpers/Chat/ChatHelper";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "data":{}
}
const setTypingMsg = (curState,userId,typingMsg) => {
    let userData = {...curState[userId],"typedMessage":typingMsg}
    return { ...curState,[userId]:userData}
   
}

const clearChatHandle = (chatId,stateData)=>{
    return {
        ...stateData,
        [chatId]: {
          messages: {}
        }
      }
}
const deleteChatHandle = (data,stateData)=>{
    const currentData = { ...stateData };
    delete currentData[data.fromUserId];
    return currentData
}

const chatConversationHistory = createSlice({
    name:'chatConversationHistory',
    initialState,
    reducers:{
        addChatConversationHistory: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": getChatHistoryData(payload.payload,StateToObj(_state).data)
               }
        },
        UpdateChatConversationHistory: (_state,payload)=>{
            return {
             "id" : uuidv4(),
             "data": getUpdatedHistoryData(payload.payload,StateToObj(current(_state)).data)
            }
     },
        updateUploadStatus: (_state,payload)=>{
        return {
        "id" : uuidv4(),
        "data": getUpdatedHistoryDataUpload(payload.payload,StateToObj(_state).data)
        }
    },
     ReconnectUpdateChatHistory: (_state,payload)=>{
        return {
         "id" : uuidv4(),
         "data": reconnectUpdateHistory(payload.payload,StateToObj(_state).data)
        }
    },
    UpdateMediaUploadStatus:(_state,payload)=>{
        return {
         "id" : uuidv4(),
         "data": getUpdatedHistoryDataUpload(payload.payload,StateToObj(_state).data)
        }
    },
    RetryMediaUpload : (_state,payload) => {
        return{
            "id" : uuidv4(),
            "data": updateMediaUploadStatusHistory(payload.payload,StateToObj(_state).data)
        }
    },
    CancelMediaUpload : (_state,payload) => {
        return{
            "id" : uuidv4(),
            "data": updateMediaUploadStatusHistory(payload.payload,StateToObj(_state).data)
        }
    },
    UpdateTypedMessage : (_state,payload) => {
        return{
            ..._state,
            "data": setTypingMsg(StateToObj(_state).data,payload.payload.chatId,payload.payload.message)
        }
    },
    reconnectChatMessages : (_state,payload) => {
        return{
            ..._state,
            "data": reconnectChatImagePending(payload.payload,StateToObj(_state).data)
        }
    },
    clearChatHistoryAction:(_state,payload)=>{
        return{
            ..._state,
            "data": clearChatHandle(payload.payload,StateToObj(_state).data)
        }
    },
    deleteChatHistoryAction:(_state,payload)=>{
        return{
            ..._state,
            ...{
                "id" : uuidv4(),
                "data":deleteChatHandle(payload.payload,StateToObj(_state).data)}
        }
    },
    deleteMessageForMe:(_state,payload)=>{
        return{
            ..._state,
            ...{
                "id" : uuidv4(),
                "data":updateDeletedMessageInHistory("DELETE_MESSAGE_FOR_ME",payload.payload,StateToObj(_state).data)}
        }
    },
    deleteMessageForEveryone:(_state,payload)=>{
        return{
            ..._state,
            ...{
                "id" : uuidv4(),
                "data":updateDeletedMessageInHistory("DELETE_MESSAGE_FOR_EVERYONE",payload.payload,StateToObj(_state).data)}
        }
    },
    translateMessage:(_state,payload)=>{
        return {
            ..._state,
            ...{
                "id": uuidv4(),
                "data": updateMessageTranslate(payload.payload, StateToObj(_state).data)
            }
        };
    },
    logOutChatConversation: (_state,payload)=>{
        return initialState;
    },
    }
});

export default chatConversationHistory.reducer
export const addChatConversationHistory = chatConversationHistory.actions.addChatConversationHistory
export const updateUploadStatus = chatConversationHistory.actions.updateUploadStatus
export const UpdateChatConversationHistory = chatConversationHistory.actions.UpdateChatConversationHistory
export const ReconnectUpdateChatHistory = chatConversationHistory.actions.ReconnectUpdateChatHistory
export const UpdateMediaUploadStatus = chatConversationHistory.actions.UpdateMediaUploadStatus
export const RetryMediaUpload = chatConversationHistory.actions.RetryMediaUpload
export const CancelMediaUpload = chatConversationHistory.actions.CancelMediaUpload
export const UpdateTypedMessage = chatConversationHistory.actions.UpdateTypedMessage
export const reconnectChatMessages = chatConversationHistory.actions.reconnectChatMessages
export const clearChatHistoryAction = chatConversationHistory.actions.clearChatHistoryAction
export const deleteChatHistoryAction = chatConversationHistory.actions.deleteChatHistoryAction
export const deleteMessageForMe = chatConversationHistory.actions.deleteMessageForMe
export const deleteMessageForEveryone = chatConversationHistory.actions.deleteMessageForEveryone
export const translateMessageAction = chatConversationHistory.actions.translateMessage
export const logOutChatConversation = chatConversationHistory.actions.logOutChatConversation